import { addJs } from '../utils/documentMethods';

const LOGON_CHALLENGE_CONCERN_CODE = 'lc';
const LOGON_CHALLENGE_KEY = 'logonChallenge';

export default class LogonChallengeProcessor {
  process(baseConfig: any) {
    const logonChallengeConfig = baseConfig[LOGON_CHALLENGE_KEY];
    const logonChallengeScriptSrcMin = logonChallengeConfig.script.src.minified;
    addJs(logonChallengeScriptSrcMin, 'head', { type: 'module' });
  }

  getConcernCode() {
    return LOGON_CHALLENGE_CONCERN_CODE;
  }
}
